module.exports = __webpack_public_path__ + "static/media/iconWoodburning.41ac3cf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconWoodburning.svg
// module id = 899
// module chunks = 0